module.exports = __webpack_public_path__ + "img/magazine37.941c6b5a.jpg";